import { makeStyles } from 'tss-react/mui'
import { FC } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import correctionIcon from 'assets/icons/correction-icon.svg'
import _colors from 'styles/global/_colors'
import genericStyles from 'styles/material-styles/genericStyles.js'

const useStyles = makeStyles()((theme) => ({
  error: {
    ...genericStyles.alertContainer,
    background: `linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), ${_colors.red}`,
    color: `${_colors.redDark}`,
    border: `1px solid ${_colors.red}`,
  },
  correction: {
    padding: '26px 20px',
    display: 'flex',
    background: `linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), ${_colors.blue}`,
    color: `${_colors.blueDark}`,
    border: '2px solid rgba(0, 150, 214, 0.5)',
    filter: 'drop-shadow(0px 10px 40px rgba(0, 150, 214, 0.1))',
    borderRadius: '4px',
  },
  inlineCorrectionIcon: {
    width: '18.6px',
    height: '18.6px',
    margin: '0 4px',
  },
  correctionContainerWidth: {
    maxWidth: '1031px',
    width: '1031px',
  },
  correctionMessageText: {
    display: 'flex',
    alignItems: 'center',
  },
  close: {
    marginLeft: '15px',
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
}))

interface CorrectionProps {
  onClose: () => void
}

const Correction: FC<CorrectionProps> = ({ onClose }) => {
  const { classes } = useStyles()

  return (
    <div className={classes.correction}>
      <div className={classes.correctionMessageText} id="message-id">
        Please correct the answers marked with{' '}
        <img className={classes.inlineCorrectionIcon} src={correctionIcon} alt="Correction Icon" />{' '}
        For the rest of the questions, no action is required, unless you would like to change the
        answer previously added.
      </div>
      <IconButton
        key="close"
        data-testid="corection-close-button"
        aria-label="Close"
        color="inherit"
        className={classes.close}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
    </div>
  )
}

export default Correction
